import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

import actions from './actions'
import getters from './getters'
// import types from './types'
//相关模块管理
/**
 * 公共引用文件common
 */
import store from './modules/store'
import messageStore from './modules/messageStore'
import menuListStore from './modules/menuListStore'
// 定义 getters
// const debug = process.env.NODE_ENV !== 'production'
// 创建 store 实例
export default new Vuex.Store({
	actions,
	getters,
	modules: {
		store,
		messageStore,
		menuListStore
	},
	//	 strict: debug,
})